import dayjs from "dayjs";
import { v4 as uuid } from "uuid";

export class Project {
  static END_POINT = "project";

  serno = 0;
  guid; //= uuid();

  /** (unique) 問卷登入場次代碼，可自訂但不重複
   * (不介意被看到廠商名單的話，則可取的跟場次編號一模一樣)
   */
  cid = "";

  /** 問卷.開始填寫日期 */
  quest_start = "2999-01-01 00:00:00";
  get_QuestStart_str() {
    let dt = dayjs(this.quest_start);
    return dt.year() === 2999 ? "(未開放)" : dt.format("YYYY/MM/DD");
  }

  /** 問卷.停止填寫日期 */
  quest_end = "1800-01-01 00:00:00";
  get_QuestEnd_str() {
    let dt = dayjs(this.quest_end);
    return dt.year() === 1800 ? "(未開放)" : dt.format("YYYY/MM/DD");
  }

  /** (unique) 場次代碼  */
  project_code = "";

  /** 場次名稱 */
  project_name = "";

  /** 健檢開始日 */
  rec_dt = "2999-01-01 00:00:00";
  get_RecDT_str() {
    let dt = dayjs(this.rec_dt);
    return dt.year() === 2999 ? "" : dt.format("YYYY/MM/DD");
  }

  /** 客戶資訊(代碼) */
  cust_code = "";

  /** 客戶資訊(名稱) */
  cust_name = "";

  /** 場次帳號規則 */
  account_rule: "" | "生日" | "身分證" | "員工編號" | "姓名" = "";

  /** 場次密碼規則 */
  password_rule: "" | "生日" | "身分證" | "員工編號" | "姓名" = "";

  /** 結案日期 */
  end_dt = "2999-01-01";

  /** 一般問卷基準日 */
  common_date = "2999-01-01";

  yup_pass = "0";
  constructor() {
    this.guid = uuid();
  }

  /**
   * 事業單位代碼
   */
  business_code = "";
}
